<template>
    <div class="theme-analysis-chart">
        <div class="chart-container">
            <div class="chart-header">
                <h5>
                    <i class="fal fa-chart-bar text-warning"></i> Análisis por
                    Tema
                </h5>
                <div class="legend">
                    <span class="legend-item">
                        <span class="legend-dot" style="background:#ef4444"></span>
                        Pendiente
                    </span>
                    <span class="legend-item">
                        <span class="legend-dot" style="background:#3b82f6"></span>
                        En curso
                    </span>
                    <span class="legend-item">
                        <span class="legend-dot" style="background:#10b981"></span>
                        Resuelto
                    </span>
                </div>
            </div>

            <div v-if="sortedTemas.length === 0" class="empty-state">
                Sin datos disponibles
            </div>

            <div v-else class="bars-list">
                <div
                    v-for="tema in sortedTemas"
                    :key="tema.nombre"
                    class="bar-row"
                >
                    <div class="bar-label" :title="tema.nombre">
                        {{ tema.nombre }}
                    </div>
                    <div class="bar-track">
                        <div
                            v-if="tema.pendiente > 0"
                            class="bar-segment seg-pending"
                            :style="{
                                width: pct(tema.pendiente, maxTotal) + '%',
                            }"
                            :title="`Pendiente: ${tema.pendiente}`"
                        ></div>
                        <div
                            v-if="tema.en_curso > 0"
                            class="bar-segment seg-progress"
                            :style="{
                                width: pct(tema.en_curso, maxTotal) + '%',
                            }"
                            :title="`En curso: ${tema.en_curso}`"
                        ></div>
                        <div
                            v-if="tema.resuelto > 0"
                            class="bar-segment seg-done"
                            :style="{
                                width: pct(tema.resuelto, maxTotal) + '%',
                            }"
                            :title="`Resuelto: ${tema.resuelto}`"
                        ></div>
                    </div>
                    <div class="bar-total">{{ totalOf(tema) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ThemeAnalysisChart",
    props: {
        temaAnalisis: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        sortedTemas() {
            return [...this.temaAnalisis]
                .map((t) => ({
                    nombre: t.nombre || "Sin tema",
                    pendiente: Number(t.pendiente || 0),
                    en_curso: Number(t.en_curso || 0),
                    resuelto: Number(t.resuelto || 0),
                }))
                .sort((a, b) => this.totalOf(b) - this.totalOf(a));
        },
        maxTotal() {
            const totals = this.sortedTemas.map((t) => this.totalOf(t));
            return Math.max(1, ...totals);
        },
    },
    methods: {
        totalOf(t) {
            return (
                Number(t.pendiente || 0) +
                Number(t.en_curso || 0) +
                Number(t.resuelto || 0)
            );
        },
        pct(value, max) {
            if (!max) return 0;
            return (value / max) * 100;
        },
    },
};
</script>

<style scoped>
.theme-analysis-chart {
    margin-bottom: 20px;
}

.chart-container {
    background: #ffffff;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
}

.chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 22px;
}

.chart-header h5 {
    color: #1f2937;
    font-weight: 600;
    margin: 0;
}

.legend {
    display: flex;
    align-items: center;
    gap: 18px;
    font-size: 0.82rem;
    color: #4b5563;
}

.legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.legend-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
}

.bars-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.bar-row {
    display: grid;
    grid-template-columns: 180px 1fr 32px;
    align-items: center;
    gap: 14px;
}

.bar-label {
    font-size: 0.88rem;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bar-track {
    height: 14px;
    background: #f3f4f6;
    border-radius: 999px;
    display: flex;
    overflow: hidden;
}

.bar-segment {
    height: 100%;
    transition: width 0.4s ease;
}

.seg-pending {
    background: #ef4444;
}

.seg-progress {
    background: #3b82f6;
}

.seg-done {
    background: #10b981;
}

.bar-total {
    text-align: right;
    font-weight: 700;
    color: #111827;
    font-size: 0.92rem;
}

.empty-state {
    text-align: center;
    color: #9ca3af;
    padding: 40px 0;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .chart-container {
        padding: 18px;
    }
    .bar-row {
        grid-template-columns: 110px 1fr 28px;
        gap: 10px;
    }
    .bar-label {
        font-size: 0.78rem;
    }
    .legend {
        font-size: 0.75rem;
        gap: 12px;
    }
}
</style>
